import positions from './positions';

export default {
  positions,
};
